import { h } from 'preact';
import React, { Component } from 'react';
import Purposes from './Purposes/Purposes';
import Vendors from './Vendors/Vendors';
import { PMCCPASettings } from './PMCCPASettings';
import './PMCCPA.css';
import { makeText, isActionAllowed } from '../../util';

export class PMCCPA extends Component {
  state = {
    tab: this.props.pmTab ? this.props.pmTab || 'purposes' : this.props.message.defaultTab || 'purposes',
    loading: true
  }
  changeTab = (tab) => this.setState({ tab })
  linkHover = (e, which) => {
    e.target.style.color = which.color;
    e.target.style.textDecoration = which.textDecoration;
    e.target.style.fontWeight = which.fontWeight;
  }
  render() {
    const Settings = new PMCCPASettings(this.props.component.settings);
    const { language } = this.props;
    let { tab } = this.state;

    const data = this.props.pmData || {};

    /* DEV MODE ONLY */
    let devActions = {}, selected = false, path = JSON.stringify(this.props.path);
    if (this.props.dev) {
      devActions = { ...this.props.dev.hover };
      selected = this.props.dev.current === path;
    }

    const sectionStyles = {};
    sectionStyles.minHeight = Settings.minHeight.type === 'auto' ? 'auto' : Settings.minHeight.value + Settings.minHeight.type;
    sectionStyles.maxHeight = Settings.maxHeight.type === 'auto' ? 'auto' : Settings.maxHeight.value + Settings.maxHeight.type;
    const accordionStyles = { ...Settings.accordionsFont };
    const linkAttributes = {
      style: Settings.link,
      onMouseOver: (e) => this.linkHover(e, Settings.hover),
      onMouseOut: (e) => this.linkHover(e, Settings.link)
    };
    const className = 'message-component message-stacks pm-ccpa no-children' + this.props.className;

    const purposesText = makeText(Boolean(this.props.dev), Settings, 'purposesText', language);
    const vendorsText = makeText(Boolean(this.props.dev), Settings, 'vendorsText', language);

    const vendorList = data.vendors || [];
    if (Settings.alphabetizeVendors) {
      vendorList.sort((a, b) =>{
        if(a.name.toLowerCase() < b.name.toLowerCase()) { return -1; }
        if(a.name.toLowerCase() > b.name.toLowerCase()) { return 1; }
        return 0;
      });
    }

    return (
      <div className={selected ? className + ' on-active' : className} path={this.props.dev ? path : null} {...devActions}>

        <div className="pm-tabs">
          {data.categories && data.categories.length > 0 && (
            <button
              className={tab.includes('purposes') ? 'pm-tab active' : 'pm-tab'}
              onClick={() => this.changeTab('purposes')}
              onKeyDown={(e) => isActionAllowed(e.key) && this.changeTab('purposes')}
              title={purposesText}
              aria-label={purposesText}
            >
              {purposesText}
            </button>
          )}
          {data.vendors && data.vendors.length > 0 && (
            <button
              className={tab.includes('vendors') ? 'pm-tab active' : 'pm-tab'}
              onClick={() => this.changeTab('vendors')}
              onKeyDown={(e) => isActionAllowed(e.key) && this.changeTab('vendors')}
              title={vendorsText}
              aria-label={vendorsText}
            >
              {vendorsText}
            </button>
          )}
        </div>

        {tab.includes('purposes') && data.categories !== undefined && (
          <div className="pm-section" style={sectionStyles}>
            <Purposes
              dev={this.props.dev}
              purposes={data.categories || []}
              language={this.props.language}
              settings={Settings}
              toggleCategory={this.props.toggleCategory}
            />
          </div>
        )}

        {tab.includes('vendors') && data.vendors !== undefined && (
          <div className="pm-section" style={sectionStyles}>
            <Vendors
              dev={this.props.dev}
              vendors={data.vendors || []}
              settings={Settings}
              language={this.props.language}
              toggleVendor={this.props.toggleVendor}
            />
          </div>
        )}

      </div>
    );
  }
}
